module.exports = __webpack_public_path__ + "img/helpingBoy.6361a605.png";